const numeral = require('numeral');
/**
 * Replace das virgulas e pontos
 *
 * @param  {string} value
 *
 * @return {string}
 */
function formatCurrency(value) {
  value = numeral(value).format('0,0.00');
  value = value.replace('.', ',');
  return value.replace(',', '.');
}

/**
 * Formatação de valor para os gráficos de pilhas
 *
 * @param  {Object} tooltipItem
 * @param  {Object} data
 *
 * @return {string}
 */
function formatTooltipStack(tooltipItem, data) {
  return data.datasets[tooltipItem.datasetIndex].label + ': ' + formatCurrency(tooltipItem.yLabel);
}

/**
 * Fomatação de valor para os demais tipos de
 * gráficos
 *
 * @param  {Object} tooltipItem
 * @param  {Object} data
 *
 * @return {string}
 */
function formatTooltipCommon(tooltipItem, data) {
  return data.labels[tooltipItem.index] + ': ' + formatCurrency(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
}

/**
 * Caluculando o percentual
 *
 * @param  {Object} tooltipItem
 * @param  {Object} data
 *
 * @return {string}
 */
function formatPercentAndMoney(tooltipItem, data) {
  const tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  const dataValues = data.datasets[tooltipItem.datasetIndex].data;
  let totalValue = 0;
  dataValues.forEach((value) => {
    totalValue = parseFloat(totalValue) + parseFloat(value);
  });
  totalValue = totalValue;
  return ((tooltipValue * 100) / totalValue).toFixed(2) + '%';
}
/**
 * Limitando o tamanho da string apresentada
 * no label
 *
 * @param  {string} value
 * @param  {int} limit
 *
 * @return {string}
 */
function maxLenghtYLabel(value, limit) {
  return value.substring(0, limit) + '...';
}

export {
  formatCurrency,
  maxLenghtYLabel,
  formatTooltipStack,
  formatTooltipCommon,
  formatPercentAndMoney
};
